import { useEffect, useState } from 'react';

export type ViewMode = 'translation' | 'both';

const STORAGE_KEY = 'felo:share:viewMode';
const VALID: readonly ViewMode[] = ['translation', 'both'] as const;
const DEFAULT_MODE: ViewMode = 'both';

const isValid = (v: string | null): v is ViewMode =>
  v !== null && (VALID as readonly string[]).includes(v);

export const useShareViewMode = () => {
  const [mode, setMode] = useState<ViewMode>(() => {
    try {
      const saved = sessionStorage.getItem(STORAGE_KEY);
      // 旧版本(三选)的 'original' 残留值会落回默认 both
      return isValid(saved) ? saved : DEFAULT_MODE;
    } catch {
      return DEFAULT_MODE;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // sessionStorage 不可用时静默忽略（隐私模式等场景）
    }
  }, [mode]);

  return [mode, setMode] as const;
};
